import buildingImg from "../../asset/image/gensphere/building.jpg";
import poolImg from "../../asset/image/gensphere/Swimming-Pool.jpg";
import rtsImg from "../../asset/image/gensphere/rts.jpg";

export const genSphereIntro = [
    {
        content: (
            <p>
                <span className="title-highlighted">Gen Sphere</span> is a
                <span className="highlighted"> freehold serviced apartment in Johor Bahru City Centre </span>
                developed by Majestic Gen Sdn Bhd, designed for modern urban living.
                Strategically located in the heart of JB, this development offers residents
                excellent connectivity to key destinations such as Singapore, major highways,
                shopping malls, and business districts.
                Ideal for both homebuyers and investors, Gen Sphere combines contemporary
                architecture, lifestyle facilities, and a prime city centre location, making it
                one of the most attractive property investment opportunities in Johor Bahru.
                With its focus on convenience, accessibility, and vibrant city living, Gen Sphere
                provides a perfect balance between comfort and urban lifestyle.
            </p>
        ),
        image: buildingImg,
        alt: "Gen Sphere Building",
    },
    {
        content: (
            <p>
                From well-planned interiors to curated facilities, every detail
                reflects a commitment to quality and purposeful design —{" "}
                <span className="highlighted">
                    creating spaces that feel both inviting and enduring
                </span>
                . This is more than just a place to live — it is a setting shaped
                for modern ambitions, where everyday living is elevated by
                thoughtful design and a prime urban location.
            </p>
        ),
        image: poolImg,
        alt: "Gen Sphere Swimming Pool",
    },
    {
        content: (
            <p>
                Enjoy 
                <span className="highlighted">
                    {" "}seamless connectivity to JB Sentral and the upcoming Bukit Chagar RTS Link Station
                </span>,
                with a proposed direct link to the existing pedestrian bridge. Strategically located
                near the Malaysia–Singapore border, 
                <br/>
                <span className="title-highlighted">Gen Sphere{" "}</span>
                places residents just minutes from Johor Bahru’s key transport hub and the future
                RTS connection to Singapore.
                This prime Johor Bahru city centre location near RTS Bukit Chagar
                offers unmatched convenience for daily commuters, investors, and urban dwellers seeking
                a well-connected serviced apartment close to JB Sentral and the Singapore checkpoint.
            </p>
        ),
        image: rtsImg,
        alt: "Bukit Chagar RTS Link Station",
    }
]